export default __webpack_public_path__ + "static/media/coin2.ca5661d3.png";